<div class="margin-all-area">
  <div class="wraper-body-panel mb-3">
    <div class="wraper-body-left">
      <div class="wraper-main-section">
        <div class="global-card-section">
          <div class="common-inner-header">
            <div class="inner-header-bg">
              <div class="inner-cards-panel header-inner-hidden">
                <span class="flex-width3">Time Period</span>
                <span>Office</span>
                <span>{{scorecardFilterResponse?.class7CodeHead}}</span>
                <span>{{scorecardFilterResponse?.class8CodeHead}}</span>
                <span>Action</span>
              </div>
              <div class="inner-detail-bg">
                <span>Details</span>
              </div>
            </div>
          </div>
          <div class="common-inner-cards">
            <form [formGroup]="scoreCardKeywordForm" (ngSubmit)="getScoreCardKeywordFormSubmit()">
              <div class="inner-cards-grid">
                <div class="inner-container flex-width3">
                  <div class="inner-card-mobile">
                    <span class="font-weight-bold">From</span>
                    <div class="mobile-view-design">
                      <!--<kendo-datepicker formControlName="startDate" placeholder="" [ngClass]="{'has-error': scoreCardKeywordForm.controls.startDate.errors && (scoreCardKeywordForm.controls.startDate.touched || scoreCardKeywordForm.controls.startDate.dirty)}"></kendo-datepicker>-->
                      <div class="custom-mat-cal">
                          <mat-form-field appearance="fill">
                              <input matInput [matDatepicker]="dp" [ngClass]="{'has-error': scoreCardKeywordForm.controls.startDate.errors && (scoreCardKeywordForm.controls.startDate.touched || scoreCardKeywordForm.controls.startDate.dirty)}"
                                     formControlName="startDate" placeholder="">
                              <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                              <mat-datepicker #dp></mat-datepicker>
                          </mat-form-field>
                      </div>
                      <div class="login-error" *ngIf="scoreCardKeywordForm.controls.startDate.errors && (scoreCardKeywordForm.controls.startDate.touched || scoreCardKeywordForm.controls.startDate.dirty)">
                        <span *ngIf="scoreCardKeywordForm.controls.startDate.errors.required">Start Date is required </span>
                      </div>
                    </div>
                  </div>
                  <div class="inner-card-mobile">
                    <span class="font-weight-bold">To</span>
                    <div class="mobile-view-design">
                      <!--<kendo-datepicker formControlName="endDate" placeholder="" [ngClass]="{'has-error': scoreCardKeywordForm.controls.endDate.errors && (scoreCardKeywordForm.controls.endDate.touched || scoreCardKeywordForm.controls.endDate.dirty)}"></kendo-datepicker>-->
                      <div class="custom-mat-cal">
                          <mat-form-field appearance="fill">
                              <input matInput [matDatepicker]="dp2" [ngClass]="{'has-error': scoreCardKeywordForm.controls.endDate.errors && (scoreCardKeywordForm.controls.endDate.touched || scoreCardKeywordForm.controls.endDate.dirty)}"
                                     formControlName="endDate" placeholder="">
                              <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                              <mat-datepicker #dp2></mat-datepicker>
                          </mat-form-field>
                      </div>
                      <div class="login-error" *ngIf="scoreCardKeywordForm.controls.endDate.errors && (scoreCardKeywordForm.controls.endDate.touched || scoreCardKeywordForm.controls.endDate.dirty)">
                        <span *ngIf="scoreCardKeywordForm.controls.endDate.errors.required">End Date is required </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="inner-card-mobile">
                  <span class="space-manage">&nbsp;</span>
                  <label>Office</label>
                  <div class="mobile-view-design">
                    <select class="form-control" formControlName="officeCode" *ngIf="scorecardFilterResponse?.isOfficeDD">
                      <option value="0">-All-</option>
                      <option *ngFor="let item of scorecardFilterResponse?.officeDd ; let i= index;" [value]="item?.officeCode">{{item?.display}}</option>
                    </select>
                    <span *ngIf="!scorecardFilterResponse?.isOfficeDD">{{scorecardFilterResponse?.OfficeTxt}}</span>
                  </div>
                </div>
                <div class="inner-card-mobile">
                  <label>{{scorecardFilterResponse?.class7CodeHead}}</label>
                  <span class="space-manage">&nbsp;</span>
                  <div class="mobile-view-design">
                    <select class="form-control" formControlName="class7Code">
                      <option value="0">-None Selected-</option>
                      <option *ngFor="let item of scorecardFilterResponse?.class7CodeDd; let i= index;" [value]="item?.class7Code">{{item?.display}}</option>
                    </select>
                  </div>
                </div>
                <div class="inner-card-mobile">
                  <span class="space-manage">&nbsp;</span>
                  <label>{{scorecardFilterResponse?.class8CodeHead}}</label>
                  <div class="mobile-view-design">
                    <select class="form-control" formControlName="class8Code">
                      <option value="0">-None Selected-</option>
                      <option *ngFor="let item of scorecardFilterResponse?.class8CodeDd; let i= index;" [value]="item?.Class8Code">{{item?.display}}</option>
                    </select>
                  </div>
                </div>
                <div class="inner-card-mobile">
                  <div class="space-manage">&nbsp;</div>
                  <label>Action</label>
                  <button type="submit" class="grid-common-btn">
                    <i class="fa fa-refresh"></i>
                    <span class="grid-common-text">Refresh</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="margin-all-area">
  <div *ngIf="isShowDateWarning" class="company-2d-alert">To Date must be later than From Date</div>
  <div>
    <app-search-result-common *ngIf="user" [user]="user" [selectedUserId]="user?.cLPUserID" [headerTitle]="headerTitle" [createExportFor]="createExportFor" [eStat]="eStat" [eType]="eType" [isScoreCardGrid]=true [scoreCardData]=scorecardKeywordResponse [hiddenColumns]="hiddenColumns"></app-search-result-common>
  </div>
</div>

<div class="loader-body" *ngIf="showSpinner">
  <div class="lds-ripple"><div></div><div></div></div>
</div>
